import {listAddresses} from "@/api/address/address.js";
import {addressStore} from "@/store/store.js";

/*获取省市区信息*/
export async function getAddressListHook() {
    const res = await listAddresses()
    addressStore().setAddress(res[0].children)
}